import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

interface Props {
  customerId: number;
  isDark: boolean;
  isTitleBar: boolean;
  link?: string;
}
const useStyles = makeStyles((theme) => ({
  logo: {
    width: '100%',
    height: 'auto',
    objectFit: 'scale-down',
    display: 'block',
    padding: `0 ${theme.spacing(1.5)}px`,
  },
  logoTitleBar: {
    display: 'block',
    maxWidth: '240px',
    maxHeight: '64px',
    width: 'auto',
    height: 'auto',
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1.5)}px`,
  },
}));

const SiteLogo = (props: Props) => {
  const [image, setImage] = useState('');
  const { customerId, isDark, isTitleBar } = props;
  const classes = useStyles();

  const updateLogo = (id: number) => {
    const newLogo = `/logos/logo${id}.png`;
    const newLogoDark = `/logos/logo${id}-dark.png`;

    setImage(isDark ? newLogoDark : newLogo);
  };

  useEffect(() => {
    updateLogo(customerId);
  }, [customerId]);

  const renderImage = () => {
    return (
      <img
        alt="Company Logo"
        className={isTitleBar ? classes.logoTitleBar : classes.logo}
        src={image}
        onError={() => updateLogo(0)}
      />
    );
  };

  return props.link ? <Link to={props.link}>{renderImage()}</Link> : renderImage();
};

SiteLogo.defaultProps = { isDark: false, isTitleBar: false };

export default SiteLogo;
